<template>
    <div class="review-box text-left">
        <div class="rating">
            <small>{{langReview.rating[locale]}}:  <strong>{{review.score}}</strong><span class="text-muted">/10</span></small>
        </div>
        <div class="review-text">
            {{review.text}}
        </div>
        <div class="user-info text-right">
            <small style="margin-right: 1em"><strong>{{review.user.name}}</strong></small><small class="text-muted"> <!--{{langReview.postedOn[locale]}}--> {{review.createdAt.split('T')[0]}} {{review.createdAt.split('T')[1].split('.')[0]}}</small>
        </div>
        <font-awesome-icon v-if="!review.deleting && $store.state.authenticatedUserID === review.user._id" class="remove-icon" icon="times-circle" @click.stop="$emit('removeClicked')"/>
        <font-awesome-icon v-else-if="$store.state.authenticatedUserID === review.user._id" class="remove-icon" icon="circle-notch" :spin="true"/>
        <b-alert show variant="danger" v-if="review.errMessage && !review.deleting">{{review.errMessage}}</b-alert>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import langReview from '@/store/lang/review';

export default {
    name: "review",
    props: {
        review: Object,
        removeClicked: Function,
        deleting: Boolean
    },
    computed: mapState({
        locale: state => state.locale
    }),
    data() {
        return {
            langReview
        }
    }
}
</script>

<style scoped lang="scss">
.review-box {
  border: 1px solid darkgray;
  padding: 0.5em;
  border-radius: 5px;
  margin-top: 0.5em;
  position: relative;

  .remove-icon {
    position: absolute;
    top: -0.5em;
    right: -0.5em;
    color: #e45649;
    cursor: pointer;
  }
}
</style>